module.exports = __webpack_public_path__ + "static/img/2_3_2.fc24760a.jpg";